export default function RedirectMessage() {
  return (
    <div className="text-lg font-bold text-gray-500">
      Redirecting to login... please wait.
    </div>
  );
}
